<template>
  <div>
    <Header
      v-if="!this.$store.getters.iframeColidee"
      :window="window"
      :parameters="'adminPage'"
    />

    <div
      style="padding-top:10px;"
      :class="
        !this.$store.getters.iframeColidee
          ? window.width < 480
            ? 'container-fluid'
            : 'container'
          : null
      "
    >
      <ButtonReturnColidee
        v-if="
          this.$store.getters.iframeColidee && adminActiveComponents.parameters
        "
        :adminComponent="true"
      />
      <SearchBar v-if="adminActiveComponents.searchBar" />
      <CardsList :window="window" v-if="adminActiveComponents.cardList" />
      <Parameters v-if="adminActiveComponents.parameters" />
    </div>
    <br /><br /><br />

    <MyFooter v-if="!this.$store.getters.iframeColidee" :window="window" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "@/components/layout/Header";
import ButtonReturnColidee from "@/components/base/ButtonReturnColidee";
import CardsList from "@/components/adminPage/CardsList";
import Parameters from "@/components/adminPage/Parameters";
import SearchBar from "@/components/adminPage/components/SearchBar";
import MyFooter from "@/components/layout/MyFooter";
import Loading from "@/components/base/Loading";
export default {
  name: "Admin",
  components: {
    Header,
    ButtonReturnColidee,
    CardsList,
    Parameters,
    SearchBar,
    MyFooter,
    Loading
  },
  data() {
    return {
      window: {
        width: window.innerWidth
      }
    };
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
    },
    scrollToTopParent() {
      let message = {
        task: "scrollToTop"
      };
      window.top.postMessage(message, "*");
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },

  updated() {
    this.scrollToTopParent();
  },

  computed: {
    ...mapGetters(["adminActiveComponents"])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/page/Admin.vue